<template>
    <!-- 全景容器 -->
        <div id="pano" class="vrbox " style="width:100%;height:100vh; z-index: 99999">
          <noscript><table style="width:100%;height:100%;"><tr style="vertical-align:middle;text-align:center;"><td>ERROR:<br><br>Javascript not activated<br><br></td></tr></table></noscript>
        </div>
    <!-- 全景容器 -->
</template>

<style type="text/css">
   @media screen and (max-width: 450px) {
  } 
</style>
<script type="text/javascript">
	export default{
		name:'krpano',
		props:[],
		data(){
			return {
			}
		},
		mounted (){
            this.loadPano()
		},
		methods:{
                 loadPano(){
                   embedpano({swf:"./static/pano/krpano.swf", 
                    xml:"./static/pano/tour.xml",   
                    target : "pano", 
                    html5:"auto",
                    mobilescale:1.0, 
                    consolelog : false,          // trace krpano messages also to the browser console
                    passQueryParameters : true,     // pass query parameters of the url to krpano
                    onready : krpano_onready_callback});
                 },
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/krpano.vue